
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/list-boat",
      function () {
        return require("private-next-pages/a/list-boat/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/list-boat"])
      });
    }
  